<template>
  <div class="card mt-4 mt-md-2 table-container" v-if="notifications.length > 0">
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Notification List</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="notifications">
        <template slot="columns">
          <th>Title</th>
          <th>Description</th>
          <th>Created Date</th>
        </template>

        <template slot-scope="{row}">
          <td>{{row.title}}</td>
          <td>{{row.description}}</td>
          <td>{{formatDate(row.createdDate)}}</td>
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination :page-count="totalPage" v-model="currentPage" @input="onPageChanged"></base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { GET_NOTIFICATIONS } from '@/store/actions.type'

import { mapState } from 'vuex'

import moment from 'moment'

export default {
  name: 'notification-table',
  data() {
    return {
      currentPage: 1
    }
  },
  created() {
    this.$store.dispatch(GET_NOTIFICATIONS)
  },
  methods: {
    onPageChanged(page) {
      this.$store.dispatch(GET_NOTIFICATIONS, page)
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY hh:mm A')
    }
  },
  computed: {
    ...mapState({
      notifications: state => state.notification.notifications,
      totalPage: state => state.notification.totalPage
    })
  }
}
</script>
